import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"search-error"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.8033 15.8033C18.7322 12.8744 18.7322 8.12563 15.8033 5.1967C12.8744 2.26777 8.12563 2.26777 5.1967 5.1967C3.73124 6.66216 2.99901 8.58319 3 10.5039M15.8033 15.8033L21.1066 21.1066M15.8033 15.8033C14.3388 17.2678 12.4194 18 10.5 18","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M1.67188 14.6716L4.5003 17.5001M4.5003 17.5001L7.32873 20.3285M4.5003 17.5001L1.67188 20.3285M4.5003 17.5001L7.32873 14.6716","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SearchError = Vue.extend<IconProps>({
  name: 'SearchErrorIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'search-error',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default SearchError;
